<div class="reduce-risk-container text-center">
	<div class="reduce-risk-bottom">
		<img
			class="reduce-risk-image"
			src="../../assets/img/reduce-risk.png"
			alt=""
		/>
		<h2 class="mb-5 reduce-risk-header">
			Proactively Meet Federal <br class="d-none d-sm-block" />
			Compliance Requirements
		</h2>
		<p class="reduce-risk-content">
			Build trust and confidence in your compliance program with our
			real-time,<br class="d-none d-sm-block" />
			integrated compliance automation platform. RegScale ensures your
			compliance <br class="d-none d-sm-block" />
			artifacts are continuously kept up to date, holistically managing
			both manual and <br class="d-none d-sm-block" />
			automated assessments against federal compliance requirements.
		</p>
		<a href="https://go.regscale.com/RegScale-Create-Account">
			<button class="free-trial-btn px-5 py-2 mt-5">Learn More</button>
		</a>
	</div>

	<div
		class="
			container
			government-hero-middle
			d-flex
			flex-column flex-lg-row
			align-items-center
			justify-content-center
		"
	>
		<img
			class="change-left"
			src="../../assets/img/prepared-for-change.svg"
			alt=""
		/>

		<div class="change-right">
			<div class="text-gradient">Are You Prepared for Change?</div>
			<div class="my-3 my-lg-4 solution-underline"></div>
			<p>
				New applications are coming online at record
				<br class="d-none d-md-block" />
				speed. Shift left your agency's security and
				<br class="d-none d-md-block" />
				compliance program and ensure your compliance
				<br class="d-none d-md-block" />
				documentation is continuously up-to-date.
			</p>
		</div>
	</div>

	<div class="container">
		<h3 class="regscale-solution-header">
			75% of government agency cybersecurity
			<br class="d-none d-md-block" />
			programs are "at-risk" or "high risk" with
			<br class="d-none d-md-block" />
			significant security gaps and a lack of
			<br class="d-none d-md-block" />
			fundamental processes.
		</h3>

		<p>
			Integrating cybersecurity is the first step to upgrading your
			<br class="d-none d-sm-block" />
			relationship with compliance.
		</p>
	</div>
</div>
